var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card',{staticClass:"user-activity-bar-settings mr-3",attrs:{"show":_setup.show}},[_c('b-form-checkbox',{attrs:{"switch":""},model:{value:(_setup.enableActivityBar),callback:function ($$v) {_setup.enableActivityBar=$$v},expression:"enableActivityBar"}},[_c('b',[_vm._v("Enable Activity Bar")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }